import { useServices } from "./useServices.js";
const useCalendar = ()=>useServices().calendar;
export { useCalendar };
